export default class UserAgentManager {
    ua;

    _isTablet: boolean = false;

    _isMobile: boolean = false;

    _isPC: boolean = false;

    _isIE: boolean = false;

    _isEdge: boolean = false;

    _isChrome: boolean = false;

    _isFirefox: boolean = false;

    _isMac: boolean = false;

    _isiPhone: boolean = false;

    _isiPod: boolean = false;

    _isiPad: boolean = false;

    _isiOS: boolean = false;

    _isWindows7: boolean = false;

    _isIE11: boolean = false;

    _isSafari: boolean = false;

    /**
    * Constructor
    */
    constructor() {
      const _ua: string = navigator.userAgent;
      this.checkTablet(_ua);
      this.checkMobile(_ua);
      this.checkIE(_ua);
      this.checkEdge(_ua);
      this.checkChrome(_ua);
      this.checkFirefox(_ua);
      this.checkMac(_ua);
      this.checkPC();
      this.checkiPhone(_ua);
      this.checkiPod(_ua);
      this.checkiPad(_ua);
      this.checkWindows7(_ua);
      this.checkIE11(_ua);
      this.checkSafari(_ua);

      this.init();
    }

    get isTablet() { return this._isTablet; }

    get isMobile() { return this._isMobile; }

    get isMobileOrTablet() { return Boolean(this._isMobile || this._isTablet); }

    get isPC() { return this._isPC; }

    get isIE() { return this._isIE; }

    get isEdge() { return this._isEdge; }

    get isChrome() { return this._isChrome; }

    get isFirefox() { return this._isFirefox; }

    get isMac() { return this._isMac; }

    get isiPhone() { return this._isiPhone; }

    get isiPod() { return this._isiPod; }

    get isiPad() { return this._isiPad; }

    get isSafari() { return this._isSafari; }

    get isiOS() { return (this._isiPhone || this._isiPod || this._isiPad); }

    // eslint-disable-next-line class-methods-use-this
    get iOSversion() {
      const ua: string = navigator.userAgent.toLowerCase();
      let numString: string;
      let verArray: string[];
      if (/iphone/.test(ua)) {
        numString = ua.slice(ua.indexOf('iphone os ') + 10, ua.length);
        verArray = numString.split('_');
        return Number(verArray[0]) * 100;
      }
      if (ua.indexOf('ipad') > 0 || (ua.indexOf('macintosh') > -1 && 'ontouchend' in document)) {
        numString = ua.slice(ua.indexOf('version/') + 8, ua.indexOf('version/') + 14);
        verArray = numString.split('.');
        return Number(verArray[0]) * 100;
      }
      return 0;
    }

    get isIE11() { return this._isIE11; }

    get isWindows7() { return this._isWindows7; }

    /**
     * 初期化
     */
    init(): void {
      if (this.isMobile) document.querySelector('body').classList.add('is-Mobile-page');
      if (this.isTablet) document.querySelector('body').classList.add('is-Tablet-page');
    }

    // IE判別
    private checkIE(_ua: string): void {
      const ua = _ua.toLowerCase();
      if (ua.match(/msie/) || ua.match(/trident/)) {
        this._isIE = true;
      } else {
        this._isIE = false;
      }
    }

    // Edge判別
    private checkEdge(_ua: string): void {
      const ua = _ua.toLowerCase();
      if (ua.match(/edge/)) {
        this._isEdge = true;
      } else {
        this._isEdge = false;
      }
    }

    // chrome判別
    private checkChrome(_ua: string): void {
      const ua = _ua.toLowerCase();
      if (ua.match(/chrome/)) {
        this._isChrome = true;
      } else {
        this._isChrome = false;
      }
    }

    // Firefox判別
    private checkFirefox(_ua: string): void {
      const ua = _ua.toLowerCase();
      if (ua.match(/firefox/)) {
        this._isFirefox = true;
      } else {
        this._isFirefox = false;
      }
    }

    // Safari判別
    private checkSafari(_ua: string): void {
      const ua = _ua.toLowerCase();
      if (!ua.match(/chrome/) && ua.match(/safari/)) {
        this._isSafari = true;
      } else {
        this._isSafari = false;
      }
    }

    // タブレット判別
    private checkTablet(_ua: string): void {
      const ua = _ua.toLowerCase();
      const flag = (ua.indexOf('windows') !== -1 && ua.indexOf('touch') !== -1 && ua.indexOf('tablet pc') === -1)
            || (ua.indexOf('ipad') > 0 || (ua.indexOf('macintosh') > -1 && 'ontouchend' in document))
            || (ua.indexOf('android') !== -1 && ua.indexOf('mobile') === -1)
            || (ua.indexOf('firefox') !== -1 && ua.indexOf('tablet') !== -1)
            || ua.indexOf('kindle') !== -1
            || ua.indexOf('silk') !== -1
            || ua.indexOf('playbook') !== -1;
      if (flag) {
        this._isTablet = true;
      } else {
        this._isTablet = false;
      }
    }

    // スマホ判別
    private checkMobile(_ua: string): void {
      const ua = _ua.toLowerCase();
      const flag = (ua.indexOf('windows') !== -1 && ua.indexOf('phone') !== -1)
            || ua.indexOf('iphone') !== -1
            || ua.indexOf('ipod') !== -1
            || (ua.indexOf('android') !== -1 && ua.indexOf('mobile') !== -1)
            || (ua.indexOf('firefox') !== -1 && ua.indexOf('mobile') !== -1)
            || ua.indexOf('blackberry') !== -1;
      if (flag) {
        this._isMobile = true;
      } else {
        this._isMobile = false;
      }
    }

    // Mac判別
    private checkMac(_ua: string): void {
      const ua = _ua.toLowerCase();
      if (ua.indexOf('mac os x') > -1) {
        this._isMac = true;
      } else {
        this._isMac = false;
      }
    }

    /**
     * デバイス判別（isPC）
     */
    private checkPC(): void {
      if (!this.isTablet && !this.isMobile) this._isPC = true;
    }

    /**
     * デバイス判別（isiPad）
     */
    private checkiPad(_ua: string): void {
      const ua = _ua.toLowerCase();
      this._isiPad = false; // ua.indexOf("ipad") != -1;
      if (ua.indexOf('ipad') > 0
            || (ua.indexOf('macintosh') > -1 && 'ontouchend' in document)) {
        this._isiPad = true;
      }
    }

    /**
     * デバイス判別（isiPod）
     */
    private checkiPod(_ua: string): void {
      const ua = _ua.toLowerCase();
      this._isiPod = ua.indexOf('ipod') !== -1;
    }

    /**
     * デバイス判別（isiPad）
     */
    private checkiPhone(_ua: string): void {
      const ua = _ua.toLowerCase();
      this._isiPhone = ua.indexOf('iphone') !== -1;
    }

    /**
     * Windows7判別（isWindows7）
     */
    private checkWindows7(_ua: string): void {
      const ua = _ua.toLowerCase();
      this._isWindows7 = ua.indexOf('windows nt 6.1') !== -1;
    }

    /**
     * IE11判別（isIE11）
     */
    private checkIE11(_ua: string): void {
      this.checkIE(_ua);

      const ua = _ua.toLowerCase();
      if (this._isIE) {
        this._isIE11 = (ua.indexOf('trident/7') > -1);
      } else {
        this._isIE11 = false;
      }
    }
}
